import { Button } from 'primereact/button'
import { Card } from 'primereact/card'
import type { WeekOption } from '../hooks/useDetailedPlanFlow'

interface WeekSelectorProps {
  weeks: WeekOption[]
  onSelect: (week: WeekOption) => void
  onBack: () => void
}

const WEEKDAY_LABELS = ['日', '月', '火', '水', '木', '金', '土']

const WeekSelector: React.FC<WeekSelectorProps> = ({ weeks, onSelect, onBack }) => {
  return (
    <div className="mt-4">
      <p className="text-700 mb-3">詳細計画を作成する週を選択してください。</p>
      <div className="flex flex-column gap-2">
        {weeks.map((week) => (
          <Card
            key={week.startDate}
            className="cursor-pointer hover:bg-blue-100 border-1 surface-border"
            onClick={() => onSelect(week)}
          >
            <div className="flex align-items-center justify-content-between">
              <div>
                <span className="font-medium text-lg">{week.label}</span>
                <span className="text-600 ml-3 text-sm">
                  ({week.dates.map((d) => {
                    const day = new Date(d)
                    return `${d.slice(5).replace(/-/g, '/')} (${WEEKDAY_LABELS[day.getDay()]})`
                  }).join(', ')})
                </span>
              </div>
              <i className="pi pi-chevron-right text-500" />
            </div>
          </Card>
        ))}
        {weeks.length === 0 && (
          <p className="text-600">利用可能な日付がありません。</p>
        )}
      </div>
      <div className="flex justify-content-start mt-4">
        <Button
          label="戻る"
          icon="pi pi-arrow-left"
          severity="secondary"
          size="small"
          onClick={onBack}
        />
      </div>
    </div>
  )
}

export default WeekSelector
